export default __webpack_public_path__ + "static/media/ecosystem_log4.ea160b74.png";